import React, { useMemo, useState } from 'react';

import { ControlBar, ControlGroup, ControlSearchBox } from 'src/app/components/lib/control-bar';
import { Modal } from 'src/app/components/lib/modal';
import { ModalDataGrid } from 'src/app/components/lib/table';
import { MarketingDiscountsDiscountWizardEligibleProductList } from 'src/app/constants/table-names';
import { useDiscountProductsQuery } from 'src/app/queries/discounts/get-discount-products';

import { useDiscountWizardStateContext } from '../state';

import { ProductListGridWrapper } from './styled';
import { useFilteredProducts } from './use-filtered-products';
import { useProductListColumns } from './use-product-list-columns';

export function EligibleProductsModal({ requirement }: { requirement: number | 'reward' }) {
  const [searchString, setSearchString] = useState('');

  const { setShowEligibleProductsModal, setEligibleProductsModalRequirement } = useDiscountWizardStateContext();
  const { isLoading: productsLoading } = useDiscountProductsQuery();
  const filteredProductsFromResourceFilters = useFilteredProducts({ requirement });
  const columns = useProductListColumns();

  const filteredProductsFromSearchString = useMemo(
    () =>
      filteredProductsFromResourceFilters.filter(
        (product) =>
          product.ProductDesc.toLowerCase().includes(searchString.toLowerCase()) ||
          product.ProductNo.toLowerCase().includes(searchString.toLowerCase())
      ),
    [filteredProductsFromResourceFilters, searchString]
  );

  const onClose = () => {
    setShowEligibleProductsModal(false);
    setEligibleProductsModalRequirement('reward');
  };

  return (
    <Modal
      Content={
        <ProductListGridWrapper>
          <ControlBar margin='0 0 var(--sizes-30)'>
            <ControlGroup grow>
              <ControlSearchBox placeholder='Search products by name or SKU...' onChange={setSearchString} />
            </ControlGroup>
          </ControlBar>
          <ModalDataGrid
            columns={columns}
            disableRowHoverHighlight
            disableSelectionOnClick
            getRowId={(row) => row.ProductId}
            height='100%'
            hideActionsColumn={false}
            loading={productsLoading}
            name={MarketingDiscountsDiscountWizardEligibleProductList}
            rows={filteredProductsFromSearchString}
          />
        </ProductListGridWrapper>
      }
      height={filteredProductsFromSearchString.length > 0 ? '80%' : undefined}
      open
      primaryActions={[{ label: 'Close', onClick: onClose }]}
      title={
        requirement === 'reward' ? 'Eligible reward products' : `Eligible products for requirement ${requirement ?? ''}`
      }
      width='80%'
      onClose={onClose}
    />
  );
}
